"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EffluentTank = void 0;
const Tank_1 = require("./Tank");
const typeName = 'EffluentTank';
class EffluentTank extends Tank_1.Tank {
    constructor(ob) {
        var _a;
        super({ ...ob, type: (_a = ob.type) !== null && _a !== void 0 ? _a : typeName });
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            // name: {
            //   type: 'String',
            //   editable: true,
            //   label: 'Name',
            //   name: 'name',
            //   description: 'Name of Effluent Pond',
            //   required: true,
            // },
            // purpose: {
            //   type: 'String',
            //   editable: true,
            //   label: 'Purpose',
            //   name: 'purpose',
            //   description: 'Used for',
            // },
            // last_filled_volume: {
            //   type: 'Number',
            //   editable: false,
            //   label: 'Last Filled Volume',
            //   name: 'last_filled_volume',
            //   description: 'The last volume in the pond',
            // },
            // current_height: {
            //   type: 'Number',
            //   editable: false,
            //   label: 'Current Height',
            //   name: 'current_height',
            //   description: 'The current Height in the pond',
            // },
            // diameter: {
            //   type: 'Number',
            //   editable: true,
            //   label: 'Diameter (m)',
            //   name: 'diameter',
            //   description: 'Diameter of Effluent Pond - metre.cm',
            //   required: true,
            // },
            // depth: {
            //   type: 'Number',
            //   editable: true,
            //   label: 'Depth/height (m)',
            //   name: 'depth/Height',
            //   description: 'Depth/ Height of Effluent Pond in m.cm',
            //   required: true,
            // },
            // mountHeight: {
            //   type: 'Number',
            //   editable: true,
            //   label: 'Mount Height (m)',
            //   name: 'Mount Height',
            //   description: 'Mount Height of Effluent Pond in m',
            //   required: true,
            // },
            // constructionMaterial: {
            //   type: 'String',
            //   editable: true,
            //   label: 'Construction material',
            //   name: 'constructionMaterial',
            //   description: 'Material Effluent Pond is contructed from',
            // },
            // location: {
            //   type: 'object',
            //   editable: true,
            //   label: 'Location',
            //   name: 'location',
            //   description: 'Location of  Effluent Pond (lat/ long)',
            // },
            // // image: {
            // //   type: 'String',
            // //   editable: true,
            // //   label: 'Image',
            // //   name: 'image',
            // //   description: 'Photograph of Effluent Pond',
            // // },
            // comments: {
            //   type: 'String',
            //   editable: true,
            //   label: 'Comments',
            //   name: 'comments',
            //   description: 'Free text for info ',
            // },
        };
    }
}
exports.EffluentTank = EffluentTank;
